export default "__VITE_ASSET__BhMZWhyo__"